export const compareDecimalDigits = (num1: number, num2: number): boolean => {
    console.log("compareDecimalDigits");
    console.log(num1);
    console.log(num2);
    // Convert numbers to strings
    const strNum1 = String(num1);
    const strNum2 = String(num2);

    // Get index of decimal point
    const decimalIndexNum1 = strNum1.indexOf(".");
    const decimalIndexNum2 = strNum2.indexOf(".");

    // // If one or both numbers have no decimal point, return false
    // if (decimalIndexNum1 === -1 || decimalIndexNum2 === -1) {
    //     return false;
    // }

    // Get decimal parts of both numbers
    const decimalPartNum1 = strNum1.slice(decimalIndexNum1);
    const decimalPartNum2 = strNum2.slice(decimalIndexNum2);

    console.log("result:::", decimalPartNum1 === decimalPartNum2);

    // Compare decimal parts and return result
    return decimalPartNum1 === decimalPartNum2;
};
